<template>
    <section class="orders">
      <div style="top: 100px;position: fixed;left:0;z-index: 999;" v-if="textCopy"> 
        <div class="text" v-copy='{callback,textCopy}' style="padding: 10px;background-color: #0c0c0c;color: #fff;">复制链接</div>
      </div>
      <!-- <div class="dati-car"   v-show="list.length!=0&&!kanyidian&&kanhyidao" @click="goAskPage">查看答题活动</div>  -->
      <div class="order-container">
        <van-list 
        v-model="loading"
        :finished="finished"
        finished-text=""
        v-if="list.length != 0"
        >
          <li>
            <order-com v-if='list.length == 1' :type='100' :model='list[0]'  @goodsConcel='goodsConcel' @radioChange='radioChange' :radioArr='radioArr' :customerId='customerId && !$route.query.shareId'/>
            
            <swiper :options="swiperOption" ref="mySwiper"
                    class="mySwiper" 
                    v-if='list.length > 1'
                    >
              <!-- slides -->
              <swiper-slide v-for="(item,index) in list" class="swiperSlide t_center" :key="index">
                  <order-com :model='item' :type='100' @goodsConcel='goodsConcel' @radioChange='radioChange' :radioArr='radioArr' :customerId='customerId && !$route.query.shareId'/>
              </swiper-slide>
            </swiper>
              <!-- 选择修复选项弹窗 -->
              <div class="containerService f28" >
                <div v-for='(value,key) in serviceList' :key='key' v-if='value.length != 0'>
                  <div class="title">必选项
                    <div class='title_tip_content' v-show='tip_show && key == "requiredGoodsCuringServiceList"' @click='closeTips(key)'>
                      顾问老师对宝贝订制诊断后，给出的精选版推荐服务项，可让宝贝的成色在基础护理下有更大提升。
                    </div>
                    <div class='title_tip_content' v-show='tip1_show && key != "requiredGoodsCuringServiceList"' @click='closeTips(key)'>
                      根据你之前的需求，提供对应的服务项目； 部分服务项是有关联的，需要组合一起购买哦。
                    </div>
                  </div>
                  <ul class='seviceUl'>
                    <li  v-for='(item,index) in value' :class="{actived:item.employStatus}" >
                      <div class='curingServiceNames'>
                        <div>{{item.name}}</div>
                        <div class='symptomName'>{{item.symptomName}}</div>

                      </div>
                      <div class='flex_content' @click='selectRadio(key,item)'>
                        <div :class="{colorB:key != 'requiredGoodsCuringServiceList'}">
                          <span style='margin-right:10px'>{{item.price}}</span>
                          x{{item.serviceCount}} 
                        </div>
                        
                        <!-- <radioB style='margin-left:20px' :checked='item.employStatus' @changeRadio='selectRadio(key,item)' v-show='key != "requiredGoodsCuringServiceList"'/> -->
                      </div>
     
                    </li>
                  </ul>
                </div>
              </div>
          </li>

          <div class="bottomShare">
              <div>扫码~定制你的专属周边~</div>
              <img src="/images/base/share_ewm.png" alt="">
          </div>
          
        </van-list>
        <div v-else>
          <img src='/images/order/noOrder.png' class='no-list'>
        </div>
      </div>
      
      <div :class="[isIPX?'tool-bar2':'']" class="tool-bar f28 waitConfirmFooter" v-show='list.length != 0 && radioArr.length != 0'>
        <div class="selectMoney">
          在线服务&#x3000;共{{radioArr.length}}件&#x3000;合计：{{totleNumTrue}}
        </div>
        <div class="topay">
         
          <div class="" @click='checksubmitPay' v-if='isOwner'>去结算</div>
        </div>
      </div>
 
      <div class='myshadow' @touchmove.prevent @click='nextStep()' v-show='myShadowShow'>
        <img src='/images/order/step1.png' class='step1' v-show='step == 1'>
        <img src='/images/order/step2.png' class='step2' v-show='step == 2'>
        <img src='/images/order/step3.png' class='step3' v-show='step == 3'>
      </div>
      <van-popup  v-model="rert" style="border-radius: 15px;">
          <div style="height:330px;width:271px;margin-left:calc(50% - 135px);">
              <img src="/images/order/kanyidao-doag.png"  style="height:329px;width:271px"/>
                <img src="/images/order/tidf-bottton.png" @click="goAskPage" style="height: 40px;width: 174px;position: relative;top: -70px;left: 50px;"/>
              <img src="/images/public/hideLog.png"  style=" height: 40px;width: 40px;position: relative;top: -70px;left: calc(50% - 20px);" @click="kanyidian=false"/> 
            </div>
      </van-popup>
     </section>
    
</template>

<script>
  import loginApi from '@/axios/login'
  import orderApi from '@/axios/order'
  import wxShare from "@/assets/js/wx.share"
  import { setTimeout } from 'timers';
  import { Toast } from 'vant';
  import publicObj from '@/assets/js/public';
  import zhugeObj from '@/assets/js/track';
  import { Dialog } from 'vant';
  import getWXConfig from "@/assets/js/wx.config";
  import {swiper, swiperSlide} from 'vue-awesome-swiper'
  export default {
    name: 'onlineOrders',
    components:{swiper,swiperSlide},
    props: {
      ptype : {
        type : Number,
        default :  null
      }
    },
    data () {
      const _this = this;
      return {
        rert:false,
        swiperOption:{
          lazy: {
            loadPrevNext: true,
          },
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 15,
          height:document.documentElement.clientHeight,
          preventLinksPropagation : false,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          on:{
            slideChangeTransitionEnd: function (e) {
              _this.selectService(_this.list[this.activeIndex])
            }
          },
        },
        step : 1,
        textCopy:'',
        wringFalg:true,
        myShadowShow : false,
        tip_show : false,
        tip1_show : false,
        serviceList : [],
        isIPX:false,
        finished : false,
        loading: true,
        pageCont : {
          current : 1,
          size	 : 10
        },
        loadMore : true,
        list : [],
        radioArr : [],
        customerId : '',
        customerName : '',
        choseService : '',
        totleNumTrue : 110,
        isOwner: false,
        kanhyidao:false,
        kanyidian:false,
        isLinkFlag:true,
        dfw:true
      }
    },
    created () {
      this.isIPX=publicObj.isIPX()
      // this.isWeiXin = publicObj.isWeiXin()
      this.isWeiXin = true
      if(this.$route.query && this.$route.query.customerId) {
        console.log('customerId',this.encode(String(this.$store.state.customerId))===this.$route.query.customerId)
        if(this.encode(String(this.$store.state.customerId)) === this.$route.query.customerId) {
          this.isOwner = true
        }
      } else {
        this.isOwner = true
      }
      this.$route.query?this.customerId=this.$route.query.customerId:'';

    },
    mounted () {
      zhugeObj.track({
        title : '订单方案中-曝光',
      })
      if(this.isLinkFlag){
        this.getOnlineList();
      }
    },
    computed : {
      
    },
    methods: {
      callback(){
        let arr = [];
        this.list.forEach((res)=>{
          arr.push(res.goodsCode);
        })
        let params = {
          behaviorType : 10,
          goodsCodeList : arr.join(',')
        }
        orderApi.behavior(params).then((res)=>{
        })
      },
      goAskPage(){
        let goodsIds = []
          for(let obj of this.list){
            goodsIds.push(obj.id)
          }
          let pams = {
            bargainActivityId:this.kanhyidao.id,
            orderAmount:this.totleNumTrue,
            goodsIds:goodsIds.join(','),
          }
         this.$router.push({name:'leadIndex',query:pams})
      },
      niubi(){
        // if(this.textCopy ==''){
          this.wringFalg=false
        // }else{
          
        // }
        
      },
      convertObj(data) {
        let _result = [];
        for (let key in data) {
          let value = data[key];
          if (value.constructor == Array) {
            value.forEach(function(_value) {
              _result.push(key + "=" + _value);
            });
          } else {
            _result.push(key + '=' + value);
          }
        }
        return _result.join('&');
      },
      takeOne(){
          if(!localStorage.getItem('firstCome')){
            localStorage.setItem('firstCome',true)
          }
          let goodsIds = []
          for(let obj of this.list){
            goodsIds.push(obj.id)
          }
          let pams = {
            bargainActivityId:this.kanhyidao.id,
            orderAmount:this.totleNumTrue,
            goodsIds:goodsIds.join(','),
            token:localStorage.getItem('token')
          }
          getWXConfig()
          var dom = document.getElementById('alldoggg') //
          if(!dom){
            return
          }
          let url = this.convertObj(pams)
          // let url =''
          dom.innerHTML = '<wx-open-launch-weapp path="Bargaining/pages/lead/index.html?'+url+'" id="launch-btn"   username="gh_f36f18f6beed"><template><div style="width:200px;height:50px;"></div></template></wx-open-launch-weapp>'
      
          var launchBtn = document.getElementById('launch-btn')
          if (!launchBtn) {
          return
          }
          launchBtn.addEventListener('launch', function (e) {
              zhugeObj.track({
                  title: "自选下单页-客服按钮-点击",
              });
          })
          launchBtn.addEventListener('error', function (e) {
          console.log('fail', e.detail)
          })
      },
      //字符串转base64
      encode(str){
        // 对字符串进行编码
        var encode = encodeURI(str + 'fed33392d3a48aa149a87a38b875ba4a');
        // 对编码的字符串转化base64
        var base64 = btoa(encode);
        return base64;
      },
      kandf(){
        this.kanyidian=true
      },
      nextStep(){
        if(this.step == 3){
          this.myShadowShow = false;
          localStorage.setItem('shadowTip',true);
        }else{
          this.step++;
        }
      },
      closeTips(key){
        if(key == 'requiredGoodsCuringServiceList'){
          this.tip_show = false;
        }else{
          this.tip1_show = false;
        }
      },
      toshowtips(key){
        let _this = this;
        if(key == 'requiredGoodsCuringServiceList'){
          this.tip_show = true;
        }else{
          this.tip1_show = true;
        }
        setTimeout(()=>{
          _this.tip_show = false;
          _this.tip1_show = false;
        },4000)
      },
      submitChoseService(items){
        let params = {
          goodsId : this.choseService
        }
        let Arr = [];
        Object.keys(this.serviceList).forEach((element)=>{
          this.serviceList[element].forEach((ele)=>{
            Arr.push({
              id : ele.id,
              employStatus : ele.employStatus
            })
          })
        })
        params.goodsCuringServiceEmployList = Arr;
        orderApi.setEmployService(params).then((res)=>{
          this.totleNum();
          
          Toast('设置成功');
        }).catch(()=>{
          this.changeRadioFlase(items.id);
        })
      },

      totleNum(){
        //获取了一遍价格计算总和
        let num = 0;
            this.list.forEach(element=>{
              
              if(this.radioArr.indexOf(element.id) >= 0){
                
                element.virtualGoodsServiceBos.forEach(item=>{
                  num += item.totalPrice;
                })
              }
            })
 
            this.totleNumTrue = num
      },
      changeRadioFlase(id){

        for(var i in this.serviceList){
          this.serviceList[i].forEach((item,index)=>{
            if(item.id == id){
              item.employStatus = !item.employStatus
            }
          })
        }
      },
      //验证是否是客服
      checkCustomer(){
        return false;
      },
      selectRadio(key,item){
        zhugeObj.track({
          title: "订单列表-方案中按钮点击",
        });
        //如果是客服点击的按钮
        if(this.checkCustomer()){
          return;
        }

        if(key == 'requiredGoodsCuringServiceList'){
         
          return;
        }
        if(item.employStatus){
 
          Dialog.confirm({
            title: '提示',
            message: '您确认要取消不做该服务项吗？',
            confirmButtonText : '再想想',
            cancelButtonText : '不做了'
          }).then(() => {
            // on confirm
           
          }).catch(() => {
            // on cancel
            //改变数据状态
            this.changeRadioFlase(item.id);
            this.submitChoseService(item);
          });
        }else{
          //改变数据状态
      
          this.changeRadioFlase(item.id);
          this.submitChoseService(item);
        }
      },
      selectService(data){
          this.choseService = data.id;
          this.serviceList = {
            requiredGoodsCuringServiceList: data.virtualGoodsServiceBos
          };
      },
      checksubmitPay(){
          orderApi.unpaid().then((res)=>{
              if(!res){
                this.$router.push({name:'pay',query:{type:'scheme',orderType: 'online', onlineIdStr: this.radioArr.join(',')}})
              }else{
                orderApi.settlementConcel(res.settlementCode).then(()=>{
                    this.$router.push({name:'pay',query:{type:'scheme',orderType: 'online', onlineIdStr: this.radioArr.join(',')}})
                  })
              } 
          })
      },
      
      copaySourl(url){
        let link = encodeURIComponent(url);
        loginApi.sortUrl(link).then((res)=>{
          res = res?res:encodeURI(url)
          let text = `【付款前请仔细查看诊断方案】您好 宝贝的定制诊断方案新鲜出炉了， 付款后即可进入修复哦~
                      点击链接${res}，就能获取到宝贝的问题，针对每个问题都有提供【专业修复建议】与【预计效果】，还有最重要的每项修复费用
                      PS：有些项目是专业顾问看过实物后的建议修复项，有任何问题一定要随时微信大人哦，不需要的服务项勾掉即可~`
          this.textCopy = text
        })
      },
      getPhotos(id){
        
        if(this.ptype != 2){
          return;
        }
      
        let _this = this;
        let title;
        if(this.list.length > 1){
          title = '【包怎么拯】'+this.customerName+'快来查看你宝贝（们）的诊断方案'
        }else{
          title = '【包怎么拯】'+this.customerName+'快来查看你宝贝的诊断方案'
        }
     
        let link = _this.$store.state.serviceUrl + '/order/list/2';
  
        if(this.customerId){
          //如果是客服分享
          link = _this.$store.state.serviceUrl + '/order/list/2?source=share&shareId=' +  this.$store.state.customerId + '&customerId=' + this.customerId + '&customerName=' + this.customerName + '&utm_source=ckzdfa'
        }
        loginApi.codeConfig().then((res)=>{
          if(res.shareCopyEnabled){
            if(!this.isOwner){
              this.wringFalg=true
              this.copaySourl(link)
            }else{
              this.wringFalg=false
            }
          }
          orderApi.getPhotos(id).then((res)=>{
            setTimeout(()=>{
              let shareBody = {
                desc : '付款后立即体验包拯手艺',
                title : title,
                link : link
              }; 
              if(res[0]){
                shareBody.imgUrl = JSON.parse(res[0].originPics)[0];
              }
              
              wxShare(shareBody).then(()=>{
                let arr = [];
                _this.list.forEach((res)=>{
                  arr.push(res.goodsCode);
                })
                let params = {
                  behaviorType : 10,
                  goodsCodeList : arr.join(',')
                }
                orderApi.behavior(params).then((res)=>{
                  
                })
              });
            },1000)
          })
        })
      },
      
      radioChange(id){
        let index = this.radioArr.indexOf(id);
        if(index > -1){
          this.radioArr.splice(index,1);
        }else{
          this.radioArr.push(id);
          
        }
        this.totleNum();
      },
      
      parentsAction(){
        this.list = [];
        this.getOnlineList();
      },
      goodsConcel(id){
        
      },
      
      checkMyShadowShow(){
        let tag = localStorage.getItem('shadowTip');
        if(!tag){
          this.myShadowShow = true;
        }
      },
      getOnlineList(){
        let _this = this;
        orderApi.getOnlineList().then((res)=>{
          this.loading = false;
          this.finished = true;
          this.list = res;
          if(res.length != 0){
            this.choseService = res[0].id;
            this.serviceList = {
              requiredGoodsCuringServiceList: res[0].virtualGoodsServiceBos
            };
            setTimeout(()=>{
              if(res[0]){
                _this.getPhotos(res[0].id)
              }
            },500)
          }else{
            this.rert = false
          }
          if(res.length > 1){
            this.checkMyShadowShow();
          }
          this.radioArr = [];
          this.list.forEach(element=>{
            this.radioArr.push(element.id);
          })
          this.totleNum();
        })
      }
    }
  }
</script>

<style scoped lang="scss">
.bottomShare{
  width: 690px;
  padding-top: 20px;
  text-align: center;
  font-size: 26px;
  img{
    width: 150px;
    height: 150px;
    display: block;
    margin: 20px auto 0;
  }
}
  .colorB{
    color:#408DE6!important;
  }
  .step1{
    width: 90%;
    position: absolute;
    top:140px;
    left:40px;
  }
  .step2{
    position: absolute;
    width: 220px;
    top:300px;
    right:30px;
  }
  .step3{
    width: 250px;
    position: absolute;
    right:28px;
    top:650px;
  }
  .myshadow{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000011111;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
  }
  .tips{
    width: 32px;
    height: 32px;
    position: relative;
    top:4px;
  }
  .topay{
    color:#EEF0F1;
    height: 100%;
    width:190px;
    border-left:1px solid #EEF0F1;
    display: flex;
    align-items: center;
    div{
      font-size: 28px;
      width:190px;
      text-align:center;
      font-weight:500;
    }
  }
  .selectMoney{
    color:#EEF0F1;
    font-size:24px;
    padding-left:40px;
  }
  .curingServiceNames{
    line-height: 40px;
  }
  .symptomName{
    color:#BABBBC;
    margin-top: 5px;
  }
  .swiper-slide {
    font-size: 18px;
    background: #fff;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    width:90%;
  }
  .swiper-container{
    padding:15px;
  }
  .seviceUl{
    // margin-top: 32px;
    li{
      padding: 35px 0!important;
      margin-bottom:0!important;
      margin-top: 0!important;
      display: flex!important;
      justify-content: space-between!important;
      font-size: 24px!important;
      line-height: 35px!important;
      border-bottom:1px solid #F8F8F8!important;
    }
    .flex_content{
      display: flex;
      justify-content: flex-end;
      height: 100px;
      align-items: center;
    }
  }
  .title{
    color:#333333;
    font-size: 32px;
    font-weight:500;
    position: relative;
  }
  .title_tip_content{
    position: absolute;
    width:519px;
    // height:88px;
    background:rgba(236,237,238,1);
    border-radius:4px;
    color:#666666;
    font-size: 20px;
    line-height: 44px;
    padding:16px 22px;
    top:-20px;
    left:120px;
  }
  .containerService{
    margin-top: 20px;
    padding-bottom: 150px;
    &>div{
      margin-top: 40px;
    }
    li{
      padding: 0 30px;
      padding-left:0px;
      // height: 36px;
      display: inline-flex;
      align-items: center;
      justify-content: flex-start;
      // border-radius: 34px;
      width: 100%;
      // background: rgba(236,236,236,1);
      // border: 1px solid rgba(236,236,236,1);
      &.actived{
        // border: 1px solid #7ADFDF;
        // background: rgba(121,207,207,0.1);
      }
    }
  }

  .no-list{
    width:100%;
    margin-top: 300px;
  }
  .orders{
    position: relative;
    // height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    .order-container{
      // position: absolute;
      // top: 0;
      // left: 0;
      // bottom: 108px;
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 108px;
      .van-list{
        width: 690px;
        li{
          width:690px;
          background:rgba(255,255,255,1);
          margin-top: 30px;
        }
        .whiteBox{
          width: 100%;
          // height: 700px;
        }
        .whiteBox2{
          width: 100%;
          height: 100px;
        }
      }
    }
    .tool-bar{
      position: fixed;
      width: 710px;
      display: flex;
      z-index: 9;
      align-items: center;
      height: 82px;
      bottom: 135px;
      border-radius: 41px;
      left: 50%;
      background:#333333;
      box-shadow:0px -2px 20px 0px rgba(0,0,0,0.06);

      // box-shadow:0px -2px 20px 0px rgba(0,0,0,0.06);
      justify-content: space-between;
      margin-left: -355px;
      .select{
        display: flex;
        justify-content: center;
        padding: 0 30px;
      }
      .pay{
        margin-right: 30px;
        margin-left: 10px;
      }
      .all{
        margin-left: 20px;
        line-height: 35px;
      }
      .total{
        margin-right: 20px;
        line-height: 20px;
        position: relative;
        top:-4px;
      }
    }
    .tool-bar2{
      height: 102px;
      bottom: 150px;
      border-radius: 51px;
    }
  }
.dati-car{
  width: 208px;
  height: 70px;
  line-height: 70px;
  text-align: center;
  background: #63BFBF;
  border-radius: 44px 0px 0px 44px;
  color:#fff;
  position:fixed;
  z-index: 999;
  right: 0;
  bottom: 400px;
}
.van-popup{
      background-color: #faebd700;
}
</style>
